import { P, match } from "@stepapp/core";

import { useTranslation } from "react-i18next";

export const useErrorMessage = () => {
  const { t } = useTranslation();

  return (errorString: string) => {
    return match(errorString)
      .with(P.string.includes("wrongSmsOrPhoneNumber"), () => t("validation.smsOrPhoneNumber"))
      .with(P.string.includes("The customer does not have payment"), () =>
        t("alerts.outdatedPaymentMethod"),
      )
      .with(P.string.includes("The customer does not have a payment"), () =>
        t("alerts.outdatedPaymentMethod"),
      )
      .with(P.string.includes("Payment method not found"), () => t("alerts.outdatedPaymentMethod"))
      .with(P.string.includes("Your card does not support this type of payment"), () =>
        t("pages.chooseCard.cardNotSupportThisPayment"),
      )
      .otherwise(() => null);
  };
};
